import { render, staticRenderFns } from "./EventTags.vue?vue&type=template&id=4e511b60"
import script from "./EventTags.vue?vue&type=script&lang=js"
export * from "./EventTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports